import { css } from '@emotion/react';
import { currencyFormatter } from '@dnhb/formatters';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import { useLocation } from 'react-router-dom';
import { Collapsable, Display, DisplayLink, LabelText } from 'shared/components';
import analytics from 'shared/utility/analytics';
import { NAVIGATE, SYNC } from 'shared/wizard/actions';
import { coverageOptions, flowTypes, premiumPaymentScheme } from '../config';

const WizardFinal = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const {
    pages,
    input: {
      flow,
      applicant_dob,
      partner_dob,
      applicant_smokes,
      has_partner,
      coverage,
      coverageType,
      premium,
      duration,
      endDate,
      partner_smokes,
      payment,
    },
  } = useSelector(state => state);

  const newInsuranceFlow = flow === flowTypes.new;
  const selectedCoverageDescription = coverageOptions.find(({ value }) => value === coverageType).description;
  const selectedPaymentInterval = premiumPaymentScheme.find(({ value }) => value === payment).label.toLowerCase();
  const currentPageIndex = pages.indexOf(state?.page);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false, recalculate: null });
    analytics.send('Bereken', 'Resultaat');
  }, []);

  return (
    <Fragment>
      <LabelText
        css={css`
          margin-bottom: 24px;
        `}
      >
        Controleer hieronder je gegevens en pas ze zonodig aan.
      </LabelText>
      <Collapsable title="Je gegevens" openByDefault>
        <Display label="Geboortedatum" value={applicant_dob} />
        <Display label="Rookt" value={applicant_smokes} />
        <DisplayLink onClick={() => dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 1 })}>
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
      {has_partner && (
        <Collapsable title="Gegevens partner">
          <Display label="Geboortedatum" value={partner_dob} />
          <Display label="Rookt" value={partner_smokes} />
          <DisplayLink onClick={() => dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 2 })}>
            Gegevens aanpassen
          </DisplayLink>
        </Collapsable>
      )}
      {newInsuranceFlow ? (
        <Collapsable title="Je dekking">
          <Display label="Looptijd van de ORV" value={duration + ' jaar'} />
          <Display label="Gewenste uitkering bij overlijden" value={currencyFormatter(coverage)} />
          <Display label="Type dekking" value={selectedCoverageDescription} />
          <DisplayLink onClick={() => dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 3 })}>
            Gegevens aanpassen
          </DisplayLink>
        </Collapsable>
      ) : (
        <Collapsable title="Je huidige dekking">
          <Display label="Huidige premie" value={`${currencyFormatter(premium)} per ${selectedPaymentInterval}`} />
          <Display label="Einddatum verzekering" value={endDate} />
          <Display label="Verzekerd bedrag bij overlijden" value={currencyFormatter(coverage)} />
          <Display label="Type dekking" value={selectedCoverageDescription} />
          <DisplayLink onClick={() => dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 3 })}>
            Gegevens aanpassen
          </DisplayLink>
        </Collapsable>
      )}
    </Fragment>
  );
};

export default WizardFinal;
